import * as React from 'react';
import { useState } from 'react';
import { useMutation, useQuery } from "react-query";
import { StripeService } from "crqlar-react-common/dist/services/integrations/stripe/stripe.service";
import { Card, CircularProgress, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Typography from "@mui/material/Typography";
import { CommonThemeColors } from "crqlar-react-common/dist/components/theme";
import Button from "@mui/material/Button";
import { getSymbolForCurrency } from "crqlar-react-common/dist/utils/currency.util";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';

function PricingPageCrqlar() {

  const { t } = useTranslation();
  const [interval, setInterval] = useState<'month' | 'year'>('month');

  const pricingTableInfoQ = useQuery('pricingTableInfo', async () => {
    return await StripeService.getPricingTableInfo();
  });

  const checkoutSessionMut = useMutation(
    'checkoutSession',
    async (priceId: string) => {
      console.log("Return to", window.location.href);
      const portalSession = await StripeService.createCheckoutSession(window.location.href, priceId);
      // open in same tab
      window.open(portalSession, '_self');
    }
  );


  if (pricingTableInfoQ.isLoading) {
    return <CircularProgress />;
  }

  const products = pricingTableInfoQ.data?.products || [];
  const prices = pricingTableInfoQ.data?.prices || [];
  console.log(products, prices);

  const renderProduct = (product: any) => {
    const description = product.description;
    const marketingFeatures = product.marketingFeatures || [];

    const price = prices.find(
      (p) =>
      p.product === product.id &&
      p.recurring?.interval === interval
    );
    const billingScheme = price?.billingScheme;
    const priceCurrency = price?.currency;
    let priceAmount;
    if (billingScheme === 'per_unit') {
      priceAmount = (price?.unitAmount || 0) / 100;
    }

    if (billingScheme === 'tiered') {
      priceAmount = (price?.tiers?.[0]?.unitAmount || 0) / 100;
    }

    return (
      <Card
        sx={{
          p: 2,
          width: 300
        }}>

                <Stack gap={4} alignItems={'center'}>
                    <Typography variant={'h5'}>
                        {product.name}
                    </Typography>

                    <Stack
            direction={'row'}
            gap={0.5}
            alignItems={'flex-end'}>

                        <Stack mb={'4px'}>
                            <Typography variant={'h4'}>
                                {getSymbolForCurrency(priceCurrency)}
                            </Typography>
                        </Stack>

                        <Typography variant={'h3'}>
                            {priceAmount}
                        </Typography>

                        <Stack mb={'4px'}>
                            <Typography variant={'h4'}>/{t('per room')}</Typography>
                        </Stack>

                    </Stack>

                    <Typography sx={{
            color: CommonThemeColors.sys.text.secondary,
            minHeight: 60,
            maxWidth: 200,
            textAlign: 'center'
          }}>
                        {t('One time setup fee')} <br />

                        {description}
                    </Typography>

                    <Button
            disabled={!price?.id}
            onClick={() => price?.id && checkoutSessionMut.mutate(price.id)}
            variant="contained">

                        {t('Subscribe')}
                    </Button>

                    <Stack gap={2}>

                        <Typography>
                            {t("This includes:")}
                        </Typography>

                        {marketingFeatures.map((feature: any) =>
            <Stack
              direction={'row'}
              alignItems={'center'}
              gap={1}>


                                <CheckIcon
                sx={{
                  color: CommonThemeColors.sys.text.secondary,
                  fontSize: '14px'
                }} />


                                <Typography>
                                    {feature.name}
                                </Typography>
                            </Stack>
            )}
                    </Stack>
                </Stack>
            </Card>);

  };

  return (
    <Stack
      sx={{
        // width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 4
      }}>


            <ToggleButtonGroup
        id={'btn-interval'}
        value={interval}
        exclusive
        onChange={(e, value) => {
          if (value) setInterval(value);
        }}
        size={'small'}>

                <ToggleButton
          id={'btn-month'}
          value={'month'}>
                    {t('Monthly')}
                </ToggleButton>
                <ToggleButton
          id={'btn-year'}
          value={'year'}>
                    {t('Yearly')}
                </ToggleButton>
            </ToggleButtonGroup>

            <Stack direction={'row'} gap={2}>
                {products.map((product) => renderProduct(product))}
            </Stack>
        </Stack>);

}

export default PricingPageCrqlar;
